module.exports = __webpack_public_path__ + "static/media/tools-1.b7c2c9fa.png";